import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_material_by_lookupcode_and_projectIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupcode: string, projectId: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lookupcode: string, projectId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lookupcode: string, projectId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupcode: string, projectId: number    }) {
        if(isNil($inParams.lookupcode)) {
          return true; 
        }
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
